namespace RioERP.Common {
    export enum SMSQueuePriority {
        High = 1,
        Medium = 2,
        Low = 3
    }
    Serenity.Decorators.registerEnumType(SMSQueuePriority, 'RioERP.Common.SMSQueuePriority');
}
